import { InfoOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { REALLOCATION_FAILED_DETAIL, REALLOCATION_FAILED_TITLE } from 'common/constants/allocations';
import type { ReallocationFailureTabLabelProps } from './ReallocationFailureTabLabel.props';
import { ReallocationFailureTabBadge } from './ReallocationFailureTabLabel.styles';

// Not a button: the badge sits inside the tab link, which already leads to the page to save.
const ReallocationFailureTabLabel = ({ label }: ReallocationFailureTabLabelProps) => (
  <>
    {label}
    <Tooltip title={REALLOCATION_FAILED_DETAIL} describeChild>
      <ReallocationFailureTabBadge data-testid="reallocation-failed-tab-badge">
        {REALLOCATION_FAILED_TITLE}
        <InfoOutlined aria-hidden />
      </ReallocationFailureTabBadge>
    </Tooltip>
  </>
);

export default ReallocationFailureTabLabel;
